<app-notification
  [show]="showNotification"
  [type]="notificationType"
  [title]="notificationTitle"
  [message]="notificationMessage"
></app-notification>

<div class="modal-overlay">
  <div class="modal-content">
    <h1 class="title">Permisos</h1>

    <hr>

    <div class="permissions-cards-container">
      @for (permiso of permissionsList(); track permiso.externalId) {
      <label class="permission-card" [class.selected]="selectedPermissions().includes(permiso.externalId)">
        <input
          type="checkbox"
          [checked]="selectedPermissions().includes(permiso.externalId)"
          (change)="onPermisoChange(permiso.externalId, $event)"
        />
        <div class="permission-card-content">
          <span class="permission-card-title">{{ permiso.description }}</span>
          <p class="permission-card-description">{{ permiso.resource }}</p>
        </div>
      </label>
      }
    </div>



    <div class="modal-actions">
      <button class="button-main" (click)="onCancel()">Cancelar</button>
      <button class="button-secundary" (click)="onConfirm()">Guardar</button>
    </div>
  </div>
</div>
